import assetPath from '/app/xinglets/lebenslauf/pages/startpage/src/assets/A1.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')